/* eslint-disable react/no-array-index-key */
import React, { Suspense, Fragment, useEffect, useState } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import LoadingScreen from 'src/components/LoadingScreen';
import Alert from './components/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { setAlertMessage } from 'src/actions/alertAction';
import { message } from './constantsMessage';
import { getHomeDetails, homeDetailsEmpty } from './actions/homeActions';
import getProductType from './components/ProductType';

function Routes({ router }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    alertMessage,
    variant,
    redirect,
    asOk,
    asConfirm,
    yesAction,
    linkAction,
    okAction,
    linkMessage,
    messageAfter
  } = useSelector(state => state.alert);
  const { user, isLoginWithAccessToken, isClientChatBot } = useSelector(
    state => state.account
  );
  const { homeDetails } = useSelector(state => state.home);
  const { reports } = useSelector(state => state.report);
  const location = useLocation();
  const productType = getProductType();
  const [showLoading, setShowLoading] = useState(
    location.pathname === `/${productType.toLowerCase()}/home` &&
      isLoginWithAccessToken
  );

  useEffect(() => {
    dispatch(setAlertMessage(null));
  }, [location]);

  useEffect(() => {
    if (user?.user?.clientId) {
      dispatch(homeDetailsEmpty());
      dispatch(getHomeDetails(user.user.clientId));
    }
  }, [dispatch]);

  useEffect(() => {
    if (
      location.pathname === `/${productType.toLowerCase()}/home` &&
      isLoginWithAccessToken
    ) {
      setShowLoading(true);
      const timer = setTimeout(() => {
        setShowLoading(false);
      }, 2000); // Show loading screen for 2 seconds
      return () => clearTimeout(timer);
    }
  }, [location.pathname, isLoginWithAccessToken]);

  const renderRoutes = routes => {
    return routes ? (
      <Suspense
        fallback={
          <LoadingScreen
            text={
              isLoginWithAccessToken && !homeDetails
                ? isClientChatBot
                  ? 'Password updated successfully. Logging in now...'
                  : 'Success! Your account is verified. Logging in now...'
                : ''
            }
          />
        }
      >
        <Switch>
          {routes.map((route, i) => {
            const Guard = route.guard || Fragment;
            const Layout = route.layout || Fragment;
            const Component = route.component;
            return (
              <Route
                key={i}
                path={route.path}
                exact={route.exact}
                render={props =>
                  route.path === `/${productType.toLowerCase()}/home` &&
                  showLoading ? (
                    <LoadingScreen
                      text={
                        isClientChatBot
                          ? 'Password updated successfully. Logging in now...'
                          : 'Success! Your account is verified. Logging in now...'
                      }
                    />
                  ) : (
                    <Guard>
                      <Layout>
                        {alertMessage && (
                          <Alert
                            message={
                              variant === 'error' && !asConfirm
                                ? alertMessage.status === 1005
                                  ? message.emailAlready
                                  : alertMessage.status === 1060
                                  ? message.accountNotVerified
                                  : alertMessage.error
                                  ? alertMessage.error
                                  : alertMessage
                                : alertMessage
                            }
                            asOk={asOk}
                            handleOk={() => {
                              dispatch(setAlertMessage(null));
                              redirect && history.push(redirect);
                              okAction && okAction();
                            }}
                            asConfirm={asConfirm}
                            handleYes={() => {
                              yesAction && yesAction();
                              dispatch(setAlertMessage(null));
                              if (redirect) {
                                redirect === 'goBack'
                                  ? history.goBack()
                                  : history.push(redirect);
                              }
                            }}
                            link={
                              linkMessage ||
                              ((alertMessage.status === 1005 ||
                                alertMessage.status === 1060) &&
                                'here')
                            }
                            handleLink={() => {
                              linkAction && linkAction();
                              dispatch(setAlertMessage(null));
                              redirect && history.push(redirect);
                            }}
                            messageAfter={
                              messageAfter ||
                              (alertMessage.status === 1005 && ' to login.')
                            }
                            variant={variant}
                            handleClose={() => {
                              if (redirect) {
                                history.push(redirect);
                              }
                              dispatch(setAlertMessage(null));
                            }}
                          />
                        )}
                        {route.routes ? (
                          renderRoutes(route.routes)
                        ) : (
                          <Component {...props} />
                        )}
                      </Layout>
                    </Guard>
                  )
                }
              />
            );
          })}
        </Switch>
      </Suspense>
    ) : null;
  };

  return renderRoutes(router);
}

export default Routes;
